<nav #nav [attr.data-boostoffer]="!!boostOfferTag">
	<cdx-search-filters *ngIf="(breakPointService.device$ | async) !== device.MOBILE">
		<ul>
			<ng-container *ngIf="dasFacetsRoute.length; else NoDasFacetRoute">
				<li *ngFor="let facet of dasFacets; trackBy: facetsTrackFn; let i = index">
					<a
						[routerLink]="[dasFacetsRoute[i]]"
						[queryParams]="dasFacetsQueryParams[i]"
						(click)="handleClickDasFacet($event)"
						[attr.data-facet-data]="facet | json"
						[tabindex]="i"
						class="dasFacetHref"
					>
						{{ facet.name | titlecase }} ({{ facet.productCount }})
					</a>
				</li>
			</ng-container>
			<ng-template #NoDasFacetRoute>
				<li *ngFor="let facet of dasFacets; trackBy: facetsTrackFn; let i = index">
					<h2 (click)="onFacetChanged($event)" [attr.data-facet-data]="facet | json" [tabindex]="i">
						{{ facet.name | titlecase }} ({{ facet.productCount }})
					</h2>
				</li>
			</ng-template>
		</ul>
		<ng-container *ngIf="selectedDasFacets?.length">
			<search-filter-tags
				*ngIf="selectedDasFacets?.length"
				[filters]="selectedDasFacets"
				class="searchFilterTags"
				(removeFilter)="onRemoveFilter($event)"
				(removeAllFilters)="onRemoveAllFilters()"
			></search-filter-tags>
		</ng-container>
	</cdx-search-filters>
	<ng-container *ngIf="(breakPointService.device$ | async) === device.MOBILE">
		<cdx-search-filters [includeIcon]="true" title="Filters" *ngIf="dasFacets?.length">
			<ul>
				<h4 class="heading--5">Categories</h4>
				<ng-container *ngIf="dasFacetsRoute.length; else NoDasFacetRouteMobile">
					<li *ngFor="let facet of dasFacets; trackBy: facetsTrackFn; let i = index">
						<a
							[routerLink]="dasFacetsRoute[i]"
							[queryParams]="dasFacetsQueryParams[i]"
							(click)="handleClickDasFacet($event)"
							[attr.data-facet-data]="facet | json"
							[tabindex]="i"
							class="dasFacetHrefMobile"
						>
							{{ facet.name | titlecase }} ({{ facet.productCount }})
						</a>
					</li>
				</ng-container>
				<ng-template #NoDasFacetRouteMobile>
					<li *ngFor="let facet of dasFacets; trackBy: facetsTrackFn; let i = index">
						<button type="button" (click)="onFacetChanged($event)" [attr.data-facet-data]="facet | json">
							{{ facet.name | titlecase }} ({{ facet.productCount }})
						</button>
					</li>
				</ng-template>
			</ul>
			<ng-container *ngIf="selectedDasFacets?.length">
				<search-filter-tags
					*ngIf="selectedDasFacets?.length"
					[filters]="selectedDasFacets"
					class="searchFilterTags"
					(removeFilter)="onRemoveFilter($event)"
					(removeAllFilters)="onRemoveAllFilters()"
				></search-filter-tags>
			</ng-container>
			<hr />
			<ng-container *ngFor="let group of filterGroups">
				<ul>
					<h4 class="heading--5">{{ group[0].group }}</h4>
					<li *ngFor="let filter of group; trackBy: facetsTrackFn">
						<input
							type="checkbox"
							[attr.name]="filter.name"
							[attr.id]="filter.name"
							(change)="onFilterChanged($event)"
							[attr.data-filter-data]="filter | json"
							[checked]="isFilterSelected(filter)"
						/>
						<label [for]="filter.name">{{ filter.name | titlecase }} ({{ filter.productCount }})</label>
					</li>
				</ul>
				<hr />
				<search-filter-disclaimer *ngIf="canShowDisclaimer(group[0])"></search-filter-disclaimer>
			</ng-container>
			<ng-container *ngIf="selectedFilters?.length">
				<hr />
				<button fillStyle="flat" cdxButton (click)="onClearFilters()">Clear Filter</button>
			</ng-container>
		</cdx-search-filters>
	</ng-container>
</nav>
